import axios from "axios";

export const getCredentials = async (credentialNumber) => {
  try {
    const credentials = `https://credencialesclub.lavoz.com.ar/api/crm?credential=${credentialNumber}`;
    const data = await axios
      .get(credentials, {
        headers: {
          Authorization: `Bearer 676840df68c9d332ef50e5ab48e75d5e`,
        },
      })
      .then((response) => {
        return response.data;
      });
    return data;
  } catch (error) {
    console.log(error);
  }
};
